import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSignUp as amplifyConfirmSignUp, AuthError } from 'aws-amplify/auth';
import PianoBackground from '../../assets/images/pianoBackground.png';
import Logo from 'Components/Logo';
import { CustomCircularProgress } from 'Components/StyledComponents';
import CheckIcon from '@mui/icons-material/Check';
import { handleAuthErrors } from 'Utils/Forms';
import * as authActions from 'Actions/auth';
import * as eventActions from 'Actions/events';
import { AppDispatch } from 'Reducers';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';

const Verification: React.FC = () => {
  const [verified, setVerified] = React.useState(false);
  const [error, setError] = React.useState('');
  const auth = useAuthWrapperContext();

  const navigate = useNavigate();
  const search = useLocation().search.slice(1);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (auth.user) {
      console.log('user is already logged in, navigating to roadmap');
      navigate('/signin');
    }
  }, [auth.user, navigate]);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const params: { [key: string]: string } = {};
    for (const [key, value] of query.entries()) {
      params[key] = value;
    }

    if (params['user_name'] && params['confirmation_code'] && params['email']) {
      // If opened on an ipad, verify via the app. Othersise, use web.
      // Later on we will want to do the same with ios once we support mobile.
      amplifyConfirmSignUp({
        username: params['user_name'],
        confirmationCode: params['confirmation_code'],
      })
        .then(() => {
          setVerified(true);
          dispatch(eventActions.accountVerifiedAction());
          console.log('navigating to sign in with verified email:', params['email']);
          if (auth.tempSignUpPass && params['email']) {
            const email = params['email'].replace(' ', '+'); // the "+" gets lost b/c it's assumed to be a url encoding
            auth.logInUsername(email, auth.tempSignUpPass, '');
          } else {
            console.warn('pending email or phone number not found, so navigating to sign in');
            navigate('/signin');
          }
        })
        .catch((error: Error) => {
          const authError = error as unknown as AuthError;
          const err = handleAuthErrors(authError);
          console.log(err);
          // clear temp pass in case it's somehow the wrong one
          dispatch(authActions.setTempSignUpPass(undefined));
          if (err?.name) setError(err.name);
          if (err?.unknown) setError(err.unknown);
        });
    } else {
      console.log('one of the attributes was not found');
      console.log(params);
      console.log(auth);
      navigate('/signin');
    }
  }, [auth.tempSignUpPass, auth, dispatch, navigate, search]);

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        style={{
          height: '100vh',
          opacity: 0.3,
          position: 'absolute',
        }}
        src={PianoBackground}
        alt="piano-background"
      ></img>
      <Box className="page-div-styles">
        <Box className="filter-div-styles">
          <Box className="sign-in-div-styles">
            <Logo />
            <Box className="desc-container welcome-container">
              <Typography variant="h3" className="title-welcome" style={{ marginTop: '50px' }}>
                {!verified && 'Verification Pending'}
                {verified && 'Success'}
              </Typography>
              {((!verified && !error) || auth.processPending) && <CustomCircularProgress />}
              {verified && !error && !auth.processPending && (
                <CheckIcon color="success" sx={{ height: '80px', width: '80px' }} />
              )}
              {error && <Typography color="red">{error}</Typography>}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Verification;
